import React from 'react';
import PropTypes from 'prop-types';
import HyperLink from 'common/icons/VirtualEmbed';
import { EmbedPlaceholderContainer, EmbedPlaceholderButton } from './EmbedPlaceholder.styles';

const ADD_EMBED_CODE_TEXT = 'Add Embed Code';
const ERROR_RELOAD_TEXT = 'An error occurred. Please click here to reload this page';

const EmbedPlaceholder = ({ onClick, editing = true }) => (
    <EmbedPlaceholderContainer>
        <EmbedPlaceholderButton onClick={onClick}>
            {editing && <HyperLink />}
            {editing ? ADD_EMBED_CODE_TEXT : ERROR_RELOAD_TEXT}
        </EmbedPlaceholderButton>
    </EmbedPlaceholderContainer>
);

EmbedPlaceholder.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default EmbedPlaceholder;
